import { css } from '@emotion/react'

import * as styles from '@twisto/styles'

export const optionSelect = css`
  width: 100%;
  display: flex;
  line-height: unset;
`

export const flag = css`
  height: ${styles.size[24]};
`
